<template>
  <div class="quiz__step" id="step-3">
    <div class="quiz__tab-item-wrap">
      <div class="quiz__aside">

        <btn-back
            :text="translate.masterBackText"
            @backToStep="backToStep"
        />

        <div class="quiz__number">
<!--          <div class="quiz__number-title">{{ translate.masterLongText }}</div>-->
          <div class="number">
            <button type="button" class="number__btn long__btn--minus" @click="longMinus">
              <span class="btn-minus"></span>
            </button>
            <input class="number__input" v-model="long" type="number" />
            <button type="button" class="number__btn long__btn--plus" @click="longPlus">
              <span class="btn-plus"></span>
            </button>
          </div>
           <div class="let">м.</div>
        </div>
      </div>
      <div class="quiz__content">
        <div v-if="isLiquid && texts && texts['longText'+lang]" v-html="texts['longText'+lang]"></div>
        <div v-if="isLoose && texts && texts['longTextDry'+lang]" v-html="texts['longTextDry'+lang]"></div>
      </div>
    </div>

  </div>
</template>

<script>
import BtnBack from "../BtnBack.vue";
export default {
  name: "longParamComponent",
  components: {BtnBack},
  props: ['translate', 'longParam', 'isLiquid', 'isLoose', 'texts', 'lang', 'stepTwo', 'step', 'defaultNumberType', 'defaultLetterType'],
  data(){
      return{
        long: this.longParam ? this.longParam/10 : 0.2,
        number: this.defaultNumberType,
        letter: this.defaultLetterType
      }
  },
  watch:{
    long(){

      this.$emit('changeNumberType', this.number);
      this.$emit('changeLetterType', this.letter);

      let newVal = this.checkrangeLongParam(this.long);

      this.long = newVal;
      this.$emit('changeLong', parseInt(newVal * 10));

      if(this.long <= 2 ) this.$emit('changeNextCount', 0);

      if(this.isLiquid){

        if(this.stepTwo == 'low' && this.long > 2) {
          this.$emit('changeNumberType', 3);
          this.$emit('changeLetterType', 'В');
          this.goNextStep();
        }

        if(this.stepTwo == 'hight' && this.long > 2){
          this.$emit('changeNumberType', 4);
          this.$emit('changeLetterType', 'В');
          this.goNextStep();
        }

      }

      if(this.isLoose){

        //Низкая диэл.проницаемость (3Д, 3Г, 3Т, 3С)
        if(this.stepTwo == 'wet'){
          this.$emit('changeNumberType', 3);
          //this.$emit('changeLetterType', 'Д');
          //this.goNextStep();
        }

        //Высокая диэл.проницаемость (4Т, 4Д)
        if(this.long > 2 && this.stepTwo == 'drym'){
          this.$emit('changeNumberType', 4);
          this.$emit('changeLetterType', 'Д');
          this.goNextStep();
        }
        if(this.long <= 2 && this.stepTwo == 'drym'){
          this.$emit('changeNumberType', 4);
          this.$emit('changeLetterType', 'Т');
          this.goNextStep();
        }
      }


    },
    step(){
      if(this.step == 3){
         this.long = 0.2;
      }
    }
  },

  methods:{
    backToStep(){
      this.long = 0.2;
      this.$emit('backToStep')
    },
    getVariants(variants, name){
      return (variants.filter(element => element.step == name));
    },

    longMinus(){
      let newVal = parseFloat(this.long) - 0.1;
      newVal = this.checkrangeLongParam(newVal);
      this.long = newVal;
    },
    longPlus(){
      let newVal = parseFloat(this.long) + 0.1;
      newVal = this.checkrangeLongParam(newVal);
      this.long = newVal;
    },
    checkrangeLongParam(newVal){
      if(this.isLiquid && newVal >= 10) newVal = 10;
      if(this.isLoose &&  newVal >= 30) newVal = 30;

      if(newVal <= 0.2) newVal = 0.2;

      return parseFloat(newVal).toFixed(1);

    },
    //пропускает следующий шаг с налипанием и наличием статического эллектричества
    goNextStep(){
      this.$emit('changeNextCount', parseInt(this.step)+3);
    }
  }
}
</script>

<style scoped>

.quiz__number{
  display: flex;
  align-items: center;
}
.let{
  margin-left: 8px;
  /*text-transform: uppercase;*/
  color: #5a6c7d;
  line-height: 1;
  font-size: 21px;
}
</style>